import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Process from './components/Process';
import Pricing from './components/Pricing';
import B2BSection from './components/B2BSection';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SEOHead from '../../components/base/SEOHead';
import { useTranslation } from 'react-i18next';

export default function HomePage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('seo.home.title');
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', t('seo.home.description'));
    }
  }, [t]);

  return (
    <>
      <SEOHead
        title={t('seo.home.title')}
        description={t('seo.home.description')}
        keywords={t('seo.home.keywords')}
      />
      <div className="min-h-screen bg-white">
        <Navbar />
        <Hero />
        <Services />
        <Process />
        <Pricing />
        <B2BSection />
        <Contact />
        <Footer />
      </div>
    </>
  );
}